import { render, staticRenderFns } from "./listComponent.vue?vue&type=template&id=99e592d2"
import script from "./listComponent.vue?vue&type=script&lang=js"
export * from "./listComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports